import { EditableProTable } from '@ant-design/pro-components';
import React, { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';
// const waitTime = (time = 100) => {
//     return new Promise((resolve) => {
//         setTimeout(() => {
//             resolve(true);
//         }, time);
//     });
// };

const PropertyTable = (props) => {
    const [editableKeys, setEditableRowKeys] = useState([]);
    const [dataSource, setDataSource] = useState([]);
	const actionRef = useRef()

    const columns = [
        {
            title: '属性项',
            key: 'propKey',
            dataIndex: 'propKey',
			width: '15%',
			formItemProps: (form, { rowIndex }) => {
                return {
                    rules: rowIndex > 1 ? [{ required: true, message: '此项为必填项' }] : [],
                };
            },
        },
        {
            title: '属性值',
            dataIndex: 'propValue',
			width: '50%',
        },
		{
            title: '整编人',
            dataIndex: 'editor',
			width: '10%',
        },
        {
            title: '整编时间',
            dataIndex: 'update_at',
            valueType: 'dateTime',
			width: '10%',
        },
        {
            title: '操作',
            valueType: 'option',
            width: '15%',
            render: (text, record, _, action) => [
				(record.editable===undefined || record.editable) ? <a key="editable" onClick={() => {
						var _a;
						(_a = action === null || action === void 0 ? void 0 : action.startEditable) === null || _a === void 0 ? void 0 : _a.call(action, record.id);
					}}>编辑
				</a>:'',
				(record.deletable===undefined || record.deletable) ? <a key="delete" onClick={() => {
						setDataSource(dataSource.filter((item) => item.id !== record.id));
					}}>删除
				</a>:'',
			],
        },
    ];

	var index
	useEffect(() => { 
		const {showItem} = props;
		var data = [];
		index = 0
		Object.keys(showItem).forEach((key) => { 
			if ('||id||qcode||language||encryptedUrl||imageurl||encryptedImageUrl||encryptedWiki||pcode||'.indexOf("||"+key+"||")<0){
				if ('||关系类型编码||关系类型名称||url||'.indexOf("||"+key+"||")<0){
					if (key === '名称'){
						data.push({id:index, propKey:key, propValue: showItem[key], editable:true, deletable:false})
					}else{
						data.push({id:index, propKey:key, propValue: showItem[key], editable:true, deletable:true})
					}
				}else{
					data.push({id:index, propKey:key, propValue: showItem[key], editable:false, deletable:false})
				}	
				index ++;	
			}			
		});
		setDataSource(data);
	},[props.showItem])

    return (
      <EditableProTable rowKey="id" scroll={{y: '20vh'}} actionRef={actionRef} recordCreatorProps={{
                position: 'bottom',
                record: () => ({ id: dataSource.length }),
            }} loading={false} columns={columns} value={dataSource} onChange={setDataSource}
			editable={{
				type: 'multiple',
				editableKeys,
				onSave: async (rowKey, data, row) => {
					props.saveProperties(props.id, props.pcode, data.propKey, data.propValue)
					console.log(row);
					// await waitTime(2000);
				},
				onChange: setEditableRowKeys,
        	}}
			onRow={(record, rowKey) => {
				return {
					onDoubleClick: (event) => {
						if (dataSource[rowKey].editable) {
							actionRef.current.startEditable(rowKey);
						}
					},
					// onDragEnter: (event) => {
					// 	// console.log(event);
					// 	// console.log(event.dataTransfer.getData("text"));
					// 	// actionRef.current.addEditRecord({
					// 	// 	position: 'bottom',
					// 	// 	record: () => ({ id: dataSource.length }),
					// 	// })
					// },
				}
			}}
		/>
    );
};

export default PropertyTable;